/* eslint-disable max-len */

import { Container } from 'src/components/Container/Container'
import { Image } from 'src/components/Image/Image'
import { Text } from 'src/components/Text/Text'
import { config } from 'src/config'

import styles from './Timeline.module.scss'

import type { GalleryTimelineModule } from 'src/types/Module'

export const Timeline = ({ images }: GalleryTimelineModule) => (
  <Container className={styles.timeline}>
    {images.length > 0 &&
      images.map(({ id, filename, alt, title, width, height, caption }, index) => (
        <div key={id} className={styles.item}>
          <Image
            identifier={id}
            filename={filename}
            alt={alt}
            title={title}
            srcSet={[395, 790, 1580]}
            sizes={`(min-width: ${config.breakpoints.xl}px) 790px, (min-width: ${config.breakpoints.md}px) calc(100vw - 64px), calc(100vw - 32px)`}
            width={`${width}`}
            height={`${height}`}
            responsive
            lazy
          />
          <Text variant="p">
            <span className={styles.count}>{index + 1}</span>
            <span className={styles.clearfix}>{caption}</span>
          </Text>
        </div>
      ))}
  </Container>
)
